import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: 'positive' | 'negative' | 'neutral' | 'warning';
  trendLabel?: string;
  icon?: React.ReactNode;
  size?: 'default' | 'hero';
  className?: string;
}

export default function MetricCard({
  label,
  value,
  subValue,
  trend = 'neutral',
  trendLabel,
  icon,
  size = 'default',
  className = '',
}: MetricCardProps) {
  const trendColors = {
    positive: 'text-positive',
    negative: 'text-negative',
    neutral: 'text-muted-foreground',
    warning: 'text-warning-color',
  };

  const cardBg = {
    positive: 'border-l-4 border-l-[color:var(--positive)]',
    negative: 'border-l-4 border-l-[color:var(--negative)]',
    neutral: '',
    warning: 'border-l-4 border-l-[color:var(--warning)]',
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-5 ${cardBg[trend]} ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-medium text-muted-foreground tracking-wide uppercase mb-2">{label}</p>
          <p className={`tabular-nums font-bold text-foreground ${size === 'hero' ? 'text-3xl' : 'text-2xl'}`}>
            {value}
          </p>
          {subValue && (
            <p className="text-xs text-muted-foreground mt-1">{subValue}</p>
          )}
          {trendLabel && (
            <p className={`text-xs font-medium mt-1.5 ${trendColors[trend]}`}>{trendLabel}</p>
          )}
        </div>
        {icon && (
          <div className="shrink-0 w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}